import React, { FC, memo, useState } from "react";

import type {
  Direction,
  IActiveSorting,
} from "../../../hooks/useSortableTable";
import { StyledSelect } from "../../StyledSelect/StyledSelect";

interface IProps {
  onSort: (orderBy: string, direction: Direction) => void;
  activeSorting: IActiveSorting;
}

const options = [
  {
    value: "date_desc",
    label: "Date (desc)",
    orderBy: "created",
    requestValue: "desc",
  },
  {
    value: "date_asc",
    label: "Date (asc)",
    orderBy: "created",
    requestValue: "asc",
  },
  {
    value: "hits_desc",
    label: "Hits (desc)",
    orderBy: "metadata.hits",
    requestValue: "desc",
  },
  {
    value: "hits_asc",
    label: "Hits (asc)",
    orderBy: "metadata.hits",
    requestValue: "asc",
  },
];

const getActiveOption = (activeSorting: IActiveSorting) => {
  return options.find(
    option =>
      option.orderBy === activeSorting.orderBy &&
      option.requestValue === activeSorting.direction,
  );
};

const Sorting: React.FC<IProps> = memo(({ onSort, activeSorting }) => {
  const [value, setValue] = useState(getActiveOption(activeSorting));
  const handleChange = (data: any) => {
    setValue(data);
    onSort(data.orderBy, data.requestValue);
  };

  return (
    <div className="w-full d-flex flex-column mb-2 custom-filter-wrapper sorting">
      <StyledSelect
        options={options}
        isSearchable={false}
        isClearable={false}
        isBootstrap={false}
        onChange={handleChange}
        value={value}
      />
      <div className="short-explanation w-100">Sort by</div>
    </div>
  );
});

export { Sorting };
